function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.5c-2.824 0-4.829.638-6.475 1.193A2.99 2.99 0 001.5 17.532V22h8M10.5 13.5c-2.761 0-5-3.239-5-6v-1a5 5 0 0110 0v1c0 2.761-2.239 6-5 6zM16.5 22h-3v-3l6-6 3 3-6 6z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var SvgRoleButtonIcon = function SvgRoleButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEzLjVDNy4xNzYgMTMuNSA1LjE3MSAxNC4xMzggMy41MjUgMTQuNjkzQzIuMzEgMTUuMTA0IDEuNSAxNi4yNDkgMS41IDE3LjUzMlYyMkg5LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMTAuNSAxMy41QzcuNzM5IDEzLjUgNS41IDEwLjI2MSA1LjUgNy41VjYuNUM1LjUgMy43MzkgNy43MzkgMS41IDEwLjUgMS41QzEzLjI2MSAxLjUgMTUuNSAzLjczOSAxNS41IDYuNVY3LjVDMTUuNSAxMC4yNjEgMTMuMjYxIDEzLjUgMTAuNSAxMy41WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0xNi41IDIySDEzLjVWMTlMMTkuNSAxM0wyMi41IDE2TDE2LjUgMjJaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPC9zdmc+Cg==";
export { SvgRoleButtonIcon as ReactComponent };